<template>
  <q-page padding>
    <div class="row justify-center">
      <h1>Contact</h1>
    </div>
    <div class="row justify-center">
      <div class="col-7 text-center">
        <p class="text-primary text-h4">Have a question about your order, want to talk all things holds, or just looking for a chat?</p>
      </div>
    </div>
    <div class="row justify-center">
      <div class="col-7 text-center">
        <p class="text-h5">Shoot us an email at <a href="mailto:info@climbicp.com.au">info@climbicp.com.au</a> and we’ll get back to you as soon as we’ve washed the chalk off our hands!</p>
      </div>
    </div>
    <div class="row justify-center">
      <div class="col-7 text-center">
        <p class="text">You are running version {{version}}.</p>
      </div>
    </div>
  </q-page>
</template>

<script>
import version from '../version.js'
export default {
  name: 'PageHome',
  computed: {
    version () {
      return version
    }
  }
}
</script>
